import PureSkeleton from '@app/domains/common/components/PureSkeleton';
import type { ClassNameType } from '@app/domains/common/types';
import { twMerge } from 'tailwind-merge';

export default function HomeSiteAnnouncementSkeleton({ className }: ClassNameType) {
    return (
        <div className={twMerge('h-72 w-full rounded-12 bg-gray-container-base md:h-87', className)}>
            <div className="flex w-full space-x-12 p-12">
                <div>
                    <PureSkeleton
                        className="h-36 w-36 rounded-6 md:h-48 md:w-48"
                        variant="rectangular"
                        animation="pulse"
                    />
                </div>
                <div className="flex flex-1 flex-col space-y-6">
                    <PureSkeleton className="h-16 w-full md:h-22" variant="rectangular" animation="wave" />
                    <PureSkeleton className="h-16 w-[35%] md:h-22" variant="rectangular" animation="wave" />
                </div>
            </div>
        </div>
    );
}
